import BaseResource from './base-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';
import UserRole from './user-role-resource';
import SiteResource from './site-resource';

export default class UserResource extends BaseResource {
  firstName: string = null;
  lastName: string = null;
  email: string = null;
  password: string = null;
  passwordConfirmation: string = null;
  token: string = null;
  userRoles: UserRole[] = [];
  sites: SiteResource[] = [];
  isSuperUser: boolean = false;
  isManufacturer: boolean = false;

  attributes = {
    token: '!',
    isSuperUser: '<',
    isManufacturer: '<',
    sites: '<',
    userRoles: '<'
  };

  get isAdmin(): boolean {
    return this.isSuperUser || this.isManufacturer;
  }

  get name(): string {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    }
  }

  constructor(init?: Partial<UserResource>) {
    super(init, 'users');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/user-resource.ts